import { http } from "../httpHandler";

export interface UserInvitationEmail {
  id: string;
  email: string;
  verifiedAt: number | null;
  lastSentAt: number | null;
}

export const USER_INVITATION_EMAILS_KEY = "user-invitation-emails";
const path = "user-invitation-email";

export const getUserInvitationEmails = async () =>
  (await http.get<UserInvitationEmail[]>(path)).data;

export const addUserInvitationEmail = async (email: string) =>
  (await http.post<UserInvitationEmail>(path, { email })).data;

export const resendUserInvitationEmail = async (id: string) =>
  (
    await http.post<UserInvitationEmail>(
      `${path}/${encodeURIComponent(id)}/resend`,
    )
  ).data;

export const verifyUserInvitationEmail = async ({
  id,
  token,
}: {
  id: string;
  token: string;
}) =>
  (
    await http.post<UserInvitationEmail>(
      `${path}/${encodeURIComponent(id)}/verify`,
      {
        token,
      },
    )
  ).data;

export const removeUserInvitationEmail = async (id: string): Promise<void> => {
  await http.delete(`${path}/${encodeURIComponent(id)}`);
};
